export var handleOnChange = function handleOnChange(value, onChange) {
  if (onChange) {
    onChange({
      target: {
        value: value
      }
    });
  }
};